// extracted by mini-css-extract-plugin
export default {"root":"ProgressSteps_root__WDsXZ","steps":"ProgressSteps_steps__mOROY","step":"ProgressSteps_step__j-Gya","completed":"ProgressSteps_completed__krtXH"};